import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CaNumbersState } from './ca-numbers.reducer';
import { SingleCaNumberDetails } from './ca-numbers.model';

export const selectCaNumbersState = createFeatureSelector<CaNumbersState>('caNumbers');

export const selectCaNumbers = createSelector(
  selectCaNumbersState,
  (state) => state.caNumbers
);

export const selectTotal = createSelector(
  selectCaNumbersState,
  (state) => state.total
);

export const selectOffset = createSelector(
  selectCaNumbersState,
  (state) => state.offset
);

export const selectLimit = createSelector(
  selectCaNumbersState,
  (state) => state.limit
);

export const selectSort = createSelector(
  selectCaNumbersState,
  (state) => state.sort
);

export const selectQ = createSelector(
  selectCaNumbersState,
  (state) => state.q
);

export const selectLoading = createSelector(
  selectCaNumbersState,
  (state) => state.loading
);

export const selectSubmitting = createSelector(
  selectCaNumbersState,
  (state) => state.submitting
);

export const selectError = createSelector(
  selectCaNumbersState,
  (state) => state.error
);

export const selectSelectedCaNumber = createSelector(
  selectCaNumbersState,
  (state): SingleCaNumberDetails | null => state.selectedCaNumber
);
